module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0109.jpg?v=e09207a6";